import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

import { CacheService } from '../global/ng2-cache/services/cache.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router,
              private cacheService: CacheService,
              private cookieService: CookieService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let siftrockToken = localStorage.getItem('sr_token');
    const driftToken = this.cookieService.get('DrifttAuth');
    let accountId = this.cacheService.get('session') ? this.cacheService.get('session').account_id ? this.cacheService.get('session').account_id : '' : '';
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${siftrockToken}`,
        'Content-Type': 'application/json',
        'Drift-Authorization': `Bearer ${driftToken}`
      },
      setParams: {
        a: accountId
      }
    });

    return next.handle(request).pipe(
      tap((event) => {},
      err => {
      if (err.status === 401) {
        console.error(`401 error accountId: ${accountId}`);
        console.error(`sr_token: ${siftrockToken}`);
        console.error(`DrifttAuth token: ${driftToken}`);
        localStorage.removeItem('sr_token');
        document.cookie=`DrifttAuth=;expires=${new Date()};path=/`
        this.cacheService.removeAll();
        if (request.url.indexOf('/v1/user') >= 0) {
          console.error('401 error on /v1/user, redirecting to login');
          this.router.navigate(['login']);
        }
        return Observable.throw(err);
      }
      else if (err.status === 403) {
        console.error(`403 error accountId: ${accountId}`);
        console.error(`sr_token: ${siftrockToken}`);
        console.error(`DrifttAuth token: ${driftToken}`);

        // Unauthorized access attempt
        localStorage.removeItem('sr_token');
        document.cookie=`DrifttAuth=;expires=${new Date()};path=/`
        this.cacheService.removeAll();
        this.router.navigate(['login']);
      }
      else if (err.status === 404) {
        // Don't log 404's to the console
        return Observable.throw(err);
      }
      else {
        // log the error for prod troubleshooting, but re-throw to let components do something as well
        console.error(err);
        return Observable.throw(err);
      }
    }));
  }
}


// WEBPACK FOOTER //
// ./client/app/global/auth-interceptor.ts